import { SetClearCoursesData } from "../Reducers/CourseSlice";
import {
  SetUserData,
  setStatus,
  SetUserInfo,
  SetLoggedin,
  SetClearUserData,
} from "../Reducers/UserSlice";
import { STATUSES } from "../Reducers/UserSlice";
import axios from "axios";
import { toast } from "react-toastify";
const apiUrl = process.env.REACT_APP_API_URL;
export function CreateUser(values, Navigate) {
  return async function CreateUserThunk(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const response = await axios.post(`${apiUrl}User/Create`, values);
      Dispatch(setStatus(STATUSES.IDLE));
      if (response.data.errorCode === 200) {
        Dispatch(SetUserData(response.data));
        toast.success(response.data.errorMessage);
        Navigate("/verify");
        Dispatch(SetLoggedin(true));
      } else {
        Dispatch(setStatus(STATUSES.ERROR));
        toast.error(
          response?.data?.errorMessage || "An unexpected error occurred."
        );
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
      toast.error(
        e.response?.data?.errorMessage || "An unexpected error occurred."
      );
    }
  };
}
export function LoginUser(values, Navigate, previousPath) {
  return async function thunk(Dispatch, getState) {
    Dispatch(setStatus(STATUSES.LOADING));

    try {
      const res = await axios.post(`${apiUrl}User/Login`, values);
      console.log(res);
      if (res.data.errorCode === 200) {
        Dispatch(SetUserData(res.data));
        Dispatch(setStatus(STATUSES.IDLE));
        Dispatch(SetLoggedin(true));

        toast.success(res.data.errorMessage);
        if (previousPath) {
          Navigate(previousPath);
        } else if (res.data.data.roleId === 3) {
          Navigate("/stdashboard");
        } else {
          Navigate("/dashboard");
        }
      } else {
        Dispatch(setStatus(STATUSES.ERROR));
        toast.error(res.data.errorMessage);
      }
    } catch (error) {
      Dispatch(setStatus(STATUSES.ERROR));
      toast.error(error.errorMessage);
    }
  };
}

export function verifyUser(values, Navigate) {
  return async function thunk(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(`${apiUrl}User/ValidateUser`, values);
      const roleId = res.data?.data?.roleId;
      if (res.data.errorCode === 200) {
        Dispatch(SetUserData(res.data));
        Dispatch(setStatus(STATUSES.IDLE));
        toast.success(res.data.errorMessage);
        roleId === 2 ? Navigate("/dashboard") : Navigate("/stdashboard");
      } else {
        Dispatch(setStatus(STATUSES.ERROR));
        toast.error(res.data.errorMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };
}
export const GetUserDatabyId = (Token, userId) => async (Dispatch) => {
  Dispatch(setStatus(STATUSES.LOADING));
  try {
    const response = await axios.get(`${apiUrl}User/GetById?Id=${userId}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    });

    Dispatch(SetUserInfo(response?.data?.data));
    Dispatch(setStatus(STATUSES.IDLE));
  } catch (error) {}
};
export const UserUpdateInfo =
  (inputValue, Token, setUpdateUserState, onClose) => async (Dispatch) => {
    try {
      try {
        const response = await axios.post(
          `${apiUrl}User/UpdateInfo`,
          inputValue,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          }
        );

        if (response.data.errorCode === 200) {
          setUpdateUserState((prevState) => !prevState);
          toast.success(response.data.errorMessage);
        }
        onClose();
      } catch (error) {
        console.error("Error updating user data:", error);
      }
    } catch (error) {
      console.log(error);
    }
  };

export function UploadImage(Token, userData, formData, setUpdateUserState) {
  return async function basic(Dispatch, getState) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      const res = await axios.post(`${apiUrl}/upload/image`, formData, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data.errorCode === 200) {
        const uploadedImagePath = res.data?.data[0];
        try {
          await axios.post(
            `${apiUrl}User/UpdateInfo`,
            {
              aspnetUserId: userData?.aspnetUserId,
              fName: userData?.fName,
              lName: userData?.lName,
              city: userData?.city,
              profilePic: uploadedImagePath,
            },
            {
              headers: {
                Authorization: `Bearer ${Token}`,
              },
            }
          );
          Dispatch(setStatus(STATUSES.IDLE));
          setUpdateUserState((prevState) => !prevState);
        } catch (error) {
          Dispatch(setStatus(STATUSES.IDLE));
          console.error("Error updating user data:", error);
        }
      } else {
        Dispatch(setStatus(STATUSES.IDLE));
        toast.error(res.data.errorMessage);
      }
    } catch (e) {
      Dispatch(setStatus(STATUSES.ERROR));
      console.error("Error uploading image:", e);
    }
  };
}

export function logOut() {
  return async function thunk(Dispatch) {
    Dispatch(setStatus(STATUSES.LOADING));
    try {
      Dispatch(SetClearCoursesData());
      Dispatch(SetClearUserData());
    } catch (error) {
      console.log(error);
    }
  };
}
